"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.versionWithoutReadMore = void 0;
const TeaserBox_contracts_1 = require("./TeaserBox.contracts");
/**
 * List of TeaserBox versions which doesn't support/display ReadMore link
 */
exports.versionWithoutReadMore = [
    TeaserBox_contracts_1.TeaserBoxVersion['1XL'],
    TeaserBox_contracts_1.TeaserBoxVersion['2L'],
    TeaserBox_contracts_1.TeaserBoxVersion['8S'],
    TeaserBox_contracts_1.TeaserBoxVersion['8T'],
    TeaserBox_contracts_1.TeaserBoxVersion['L-4S'],
    TeaserBox_contracts_1.TeaserBoxVersion['L-8S']
];
//# sourceMappingURL=TeaserBox.config.js.map